// src/app/app-routing.module.ts or wherever your routes are defined
import { Routes } from '@angular/router';
import { OrderFlowContainerComponent } from './features/order-flow/order-flow-container/order-flow-container.component';
import { OrderListComponent } from './features/order-list/order-list.component';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { ResetComponent } from './features/auth/reset/reset.component';
import { MsalGuard } from '@azure/msal-angular';
import { LogoutComponent } from './features/auth/logout/logout.component';
import { LoginFailedComponent } from './features/auth/login/login.failed.component';
import { LoginSucessfullyComponent } from './features/auth/login/login.successfully.component';
import { RegisterSucessfullyComponent } from './features/auth/register/register.successfully.component';
import { ConfirmationComponent } from './features/auth/confirmation/confirmation.component';
import { AcceptInviteComponent } from './features/auth/accept-invite/accept-invite.component';
import { OrderSubmittedComponent } from './features/order-flow/order-submitted/order-submitted.component';
import { NotFoundComponent } from './features/error/not-found/not-found.component';
import { OrderFlowOrderSummaryOrderViewComponent } from './features/order-flow/order-flow-order-summary-order-detail/order-flow-order-summary-order-detail';

export const routes: Routes = [
  // Default redirection to the default countryCode or a specific route
  {
    path: '',
    redirectTo: '/login-successfully',
    pathMatch: 'full'
  },

  // Routes that do NOT require countryCode
  {
    path: 'register',
    component: RegisterComponent,
    data: { showHeader: true }
  },
  {
    // Therapist invite link lands here with ?token=...
    path: 'therapist-register',
    component: RegisterComponent,
    data: { showHeader: false }
  },
  { 
    path: 'login', 
    component: LoginComponent,
    data: { showHeader: true } 
  },
  { 
    path: 'reset', 
    component: ResetComponent,
    data: { showHeader: true } 
  },
  { 
    path: 'logout', 
    component: LogoutComponent,
    data: { showHeader: false } // Typically, you might want to hide the header on logout
  },
  { 
    path: 'login-failed', 
    component: LoginFailedComponent,
    data: { showHeader: false } 
  },
  { 
    path: 'login-successfully', 
    component: LoginSucessfullyComponent,
    canActivate: [MsalGuard],
    data: { showHeader: false } 
  },
  { 
    path: 'register-successfully', 
    component: RegisterSucessfullyComponent,
    data: { showHeader: false } 
  },
  {
    path: 'confirmation',
    component: ConfirmationComponent,
    data: { showHeader: false }
  },
  {
    path: 'accept-invite',
    component: AcceptInviteComponent,
    data: { showHeader: false }
  },
  { 
    path: 'order-submitted', 
    component: OrderSubmittedComponent,
    data: { showHeader: false } 
  },
  
  { 
    path: 'edit-order-from-admin/:action/:orderNumber/:token', 
    component: OrderFlowContainerComponent,
    data: { showHeader: false } 
  },

  // Routes that require countryCode
  {
    path: ':countryCode',
    children: [
      { 
        path: 'order-creation', 
        component: OrderFlowContainerComponent, 
        canActivate: [MsalGuard],
        data: { showHeader: true } 
      },
      { 
        path: 'order-creation/:action/:orderNumber', 
        component: OrderFlowContainerComponent, 
        canActivate: [MsalGuard],
        data: { showHeader: true } 
      },
      { 
        path: 'orders', 
        component: OrderListComponent,  
        canActivate: [MsalGuard],
        data: { showHeader: true } 
      },
      {
        path: 'order-summary/:orderNumber',
        component: OrderFlowOrderSummaryOrderViewComponent,
        canActivate: [MsalGuard],
        data: { showHeader: false }
      },
       {
        path: 'order-summary/:orderNumber/:token',
        component: OrderFlowOrderSummaryOrderViewComponent,
        data: { showHeader: false }
      },
      // Add more routes that require countryCode here with appropriate data
    ]
  },

  // Wildcard route for handling 404 - redirects to a specific route with header visibility as needed
  { 
    path: '**', 
    component: NotFoundComponent,
    data: { showHeader: false } 
  }
];

